export var UserRole;
(function (UserRole) {
    UserRole["CLIENT"] = "client";
    UserRole["AGENT"] = "agent";
    UserRole["ADMIN"] = "admin";
})(UserRole || (UserRole = {}));
export var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "pending";
    UserStatus["ACTIVE"] = "active";
    UserStatus["SUSPENDED"] = "suspended";
    UserStatus["BLOCKED"] = "blocked";
})(UserStatus || (UserStatus = {}));
export var VehicleType;
(function (VehicleType) {
    VehicleType["MOTORCYCLE"] = "motorcycle";
    VehicleType["BICYCLE"] = "bicycle";
    VehicleType["CAR"] = "car";
    VehicleType["TRICYCLE"] = "tricycle";
    VehicleType["FOOT"] = "foot";
})(VehicleType || (VehicleType = {}));
export var RideStatus;
(function (RideStatus) {
    RideStatus["REQUESTED"] = "requested";
    RideStatus["SEARCHING"] = "searching";
    RideStatus["ASSIGNED"] = "assigned";
    RideStatus["ACCEPTED"] = "accepted";
    RideStatus["EN_ROUTE_PICKUP"] = "en_route_pickup";
    RideStatus["PICKED_UP"] = "picked_up";
    RideStatus["EN_ROUTE_DELIVERY"] = "en_route_delivery";
    RideStatus["DELIVERED"] = "delivered";
    RideStatus["COMPLETED"] = "completed";
    RideStatus["CANCELLED"] = "cancelled";
    RideStatus["EXPIRED"] = "expired";
})(RideStatus || (RideStatus = {}));
export var RideType;
(function (RideType) {
    RideType["DELIVERY"] = "delivery";
    RideType["ERRAND"] = "errand";
    RideType["MEAL"] = "meal";
    RideType["PACKAGE"] = "package";
})(RideType || (RideType = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["PROCESSING"] = "processing";
    PaymentStatus["COMPLETED"] = "completed";
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["REFUNDED"] = "refunded";
})(PaymentStatus || (PaymentStatus = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["CASH"] = "cash";
    PaymentMethod["MOBILE_MONEY"] = "mobile_money";
    PaymentMethod["CARD"] = "card";
    PaymentMethod["WALLET"] = "wallet";
})(PaymentMethod || (PaymentMethod = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["RIDE_REQUEST"] = "ride_request";
    NotificationType["RIDE_ACCEPTED"] = "ride_accepted";
    NotificationType["RIDE_PICKED_UP"] = "ride_picked_up";
    NotificationType["RIDE_DELIVERED"] = "ride_delivered";
    NotificationType["RIDE_CANCELLED"] = "ride_cancelled";
    NotificationType["AGENT_NEARBY"] = "agent_nearby";
    NotificationType["PAYMENT_RECEIVED"] = "payment_received";
    NotificationType["WALLET_LOW"] = "wallet_low";
    NotificationType["SYSTEM"] = "system";
})(NotificationType || (NotificationType = {}));
